import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { defaultTab: String }

  connect() {
    console.log("Tabs controller connected")
    // Show default tab on load
    const defaultTab = this.defaultTabValue || this.tabTargets[0]?.dataset.tabName
    if (defaultTab) {
      this.show(defaultTab)
    }
  }

  switch(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabName
    this.show(tabName)
  }

  show(tabName) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabName === tabName) {
        // Active tab
        tab.classList.remove('border-transparent', 'text-beb-fg-3', 'hover:text-beb-fg-2', 'hover:border-beb-line')
        tab.classList.add('border-beb-accent', 'text-beb-accent-text')
      } else {
        // Inactive tabs
        tab.classList.remove('border-beb-accent', 'text-beb-accent-text')
        tab.classList.add('border-transparent', 'text-beb-fg-3', 'hover:text-beb-fg-2', 'hover:border-beb-line')
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabPanel === tabName) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }
}
